exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-ohif {\n  background-color: #b6b6b6;\n  border-color: #b6b6b6;\n  font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',\n    sans-serif;\n  font-size: 1em;\n}\n", ""]);
